import Settings from "../../../model/settings/Settings";

/**
 * Settings fetched action.
 */
export const SETTINGS_FETCHED = "SETTINGS_FETCHED";
export type SETTINGS_FETCHED = { settings: Settings }
